import * as React from "react";
const SvgPrevPage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#414141"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 1 1 6l5 5"
    />
  </svg>
);
export default SvgPrevPage;
